module.exports = __webpack_public_path__ + "static/img/banner_science.48c4d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_science.png
// module id = WUbI
// module chunks = 15